import { Organization } from '@easy-genomics/shared-lib/src/app/types/easy-genomics/organization';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '@/lib/api';

interface OrgsStoreState {
  orgs: Record<string, Organization>;

  loadOrgs: () => Promise<void>;
  loadOrg: (orgId: string) => Promise<void>;
  reset: () => void;
}

const initialState = {
  orgs: {} as Record<string, Organization>,
};

let inflight: Promise<void> | null = null;

export const useOrgsStore = create<OrgsStoreState>()(
  persist(
    (set) => ({
      ...initialState,

      loadOrgs: async () => {
        if (inflight) return inflight;
        inflight = (async () => {
          try {
            const freshOrgs: Record<string, Organization> = {};
            for (const org of await api.orgs.list()) {
              freshOrgs[org.OrganizationId] = org;
            }
            set({ orgs: freshOrgs });
          } finally {
            inflight = null;
          }
        })();
        return inflight;
      },

      loadOrg: async (orgId: string) => {
        const org = await api.orgs.orgSettings(orgId);
        set((state) => ({
          orgs: { ...state.orgs, [org.OrganizationId]: org },
        }));
      },

      reset: () => set({ ...initialState }),
    }),
    { name: 'orgsStore' },
  ),
);
